import React, { useEffect, useState } from 'react'
import { TextField } from '@mui/material/'

function EnterIDPass({ nation, setIdPass, idpass, disabled }) {
    return (
        <>
            {nation == "South African" &&
                <TextField

                    id="idpass"
                    label="RSA ID/Birth Certificate Number"
                    onChange={(e) => setIdPass(e.target.value)}
                    disabled={disabled}
                    value={idpass}
                    fullWidth
                    required
                    inputProps={{ minLength: 13, maxLength: 13, pattern: "[0-9]+", style: { textAlign: 'center' } }}
                    autoComplete='nope'


                />
            }

            {
                nation !== "South African" &&
                <TextField
                    disabled={disabled}
                    id="idpass"
                    label="Passport Number (min 8)"
                    onChange={(e) => setIdPass(e.target.value)}
                    value={idpass}
                    fullWidth
                    required
                    inputProps={{ minLength: 8, maxLength: 13, style: { textAlign: 'center' } }}
                    autoComplete='nope'

                />
            }



        </>
    )
}

export default EnterIDPass